import React from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'Components/UI'

import { Container, IconBg, TagText } from './styles'

function Tag({
  glyph = {},
  text = '',
  horizontalAlign = 'center',
  light = false,
  as = 'h3',
}) {
  return (
    text && (
      <Container justifyContent={horizontalAlign}>
        <IconBg light={light} size={[26, 26, 35]}>
          <Icon glyph={glyph} size={[12, 12, 16]} />
        </IconBg>

        <TagText as={as} fontSize={[12, 12, 16]} light={light}>
          {text}
        </TagText>
      </Container>
    )
  )
}

Tag.propTypes = {
  as: PropTypes.string,
  glyph: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  horizontalAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  light: PropTypes.bool,
  text: PropTypes.string,
}

export default Tag
